<template>
    <v-btn @click="dialog = !dialog" color="green" dark>
        Lắp mới internet
        <v-dialog v-model="dialog" max-width="80%">
            <app-card>
                <app-section-loader :status="loading.submit"></app-section-loader>
                <h4>PHIẾU LẮP MỚI INTERNET</h4>
                <p class="fs-14 grey--text">Tạo phiếu lắp mới internet</p>
                <v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="form.building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    :rules="[rules.required]"
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Số phòng"
                                    :disabled="loading.submit"
                                    v-model="form.room_id"
                                    :items="room_ids"
                                    item-text="room_id"
                                    item-value="rooms_id"
                                    prepend-icon="meeting_room"
                                    :rules="[rules.required]"
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu_date_start"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <v-text-field
                                        slot="activator"
                                        v-model="form.date_start"
                                        label="Ngày lắp đặt"
                                        :disabled="loading.submit"
                                        prepend-icon="event"
                                        readonly
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    <v-date-picker locale="vi-VI" v-model="form.date_start" @input="menu_date_start = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Mã phiếu"
                                    :disabled="loading.submit"
                                    v-model="form.receipt_id"
                                    prepend-icon="label"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Tên user"
                                    :disabled="loading.submit"
                                    v-model="form.user"
                                    prepend-icon="account_box"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Giá tiền"
                                    :disabled="loading.submit"
                                    v-model="form.price"
                                    prepend-icon="money"
                                    :rules="[rules.required]"
                                    v-currency
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Tên wifi"
                                    :disabled="loading.submit"
                                    v-model="form.wifi_name"
                                    prepend-icon="wifi"
                                    required
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Password Wifi"
                                    :disabled="loading.submit"
                                    v-model="form.wifi_password"
                                    prepend-icon="lock"
                                    required
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="loading.submit"
                            @click="cancelInput"
                        >
                            Trở về
                        </v-btn>
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="submit"
                            color="green"
                            dark
                        >
                            Tạo Phiếu
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </app-card>
        </v-dialog>
    </v-btn>
</template>
<script>
import api from "../../api";
import moment from 'moment'
import { list_building } from '../../constants/db-config'
const basements = [
	{ room_id: 'tang-ham-gb', building: "GB"},
	{ room_id: 'tang-ham-tt', building: "TT"},
	{ room_id: 'tang-ham-ma', building: "MA"},
	{ room_id: 'tang-ham-xa', building: "XA"},
	{ room_id: 'tang-ham-bn', building: "BN"},
]

export default {
    name: "lap-moi-internet-button-dialog",
    data(){
        return {
            dialog: false,

            menu_receipt_data_month: false,
            menu_date_start: false,
			rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            form: {
                receipt_id: '',
                building: '',
                room_id: '',
                date_start: '',
                wifi_name: '',
                wifi_password: '',
                price: '',
                user: '',
            },
            list_building,
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            loader: false,
            loading: {
                submit: false
            },
        }
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms.concat(basements)
        },
        room_ids(){
            return this.rooms.filter( room => room.building === this.form.building)
        }
    },
    watch: {
        dialog(nv){
            if (!nv) this.$refs.form.reset();
        }
    },
    methods: {
        cancelInput(){
            this.dialog = false
            this.$refs.form.reset();
        },
        async submit(){
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            const postData = {
                ...this.form,
                price: this.$parseCurrency(this.form.price,  "vi-VN", 'VND')
            }
            this.loading.submit = true;
            console.log(postData);
            const data = await api.createInternet(postData)
            this.loading.submit = false;
            if (data.status === 200){
                this.dialog = false;
                swal.fire('Thành công', data.data.message, 'success');
                this.$emit('reloadTable');
            } else {
                swal.fire('Lỗi', data.message, 'error');
            }
        }
    }
}
</script>